import { Checkbox, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IndustrySelectorItemProps {
	name: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	industries: { id: number; name: string }[];
	error?: string;
}

export default function IndustrySelectorItem({
	name,
	value = [],
	setValue,
	industries,
	error,
}: IndustrySelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(name, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const handleSelectAll = (selectAll: boolean) => {
		setValue(name, selectAll ? industries.map((industry) => industry.id) : [], {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => industries.find((i) => i.id === id)?.name)
							.filter(Boolean)
							.join(", ")
					: ts("select-industry")
			}
			value={value}
			onChange={handleChange}
		>
			<MenuItem key="-1" value="-1">
				<Checkbox
					checked={value.length === industries.length}
					sx={{ padding: "4px" }}
					onChange={() => handleSelectAll(value.length !== industries.length)}
				/>
				<ListItemText primary={ts("select-all")} sx={{ "& span": { m: 0 } }} />
			</MenuItem>
			{industries.map((industry) => (
				<MenuItem
					key={industry.id}
					sx={{ width: "100%", alignItems: "center", m: 0 }}
					value={industry.id}
				>
					<Checkbox checked={value.includes(industry.id)} sx={{ padding: "4px" }} />
					<ListItemText primary={industry.name} sx={{ "& span": { m: 0 } }} />
				</MenuItem>
			))}
		</Select>
	);
}
